import { get } from 'lodash'

import {
  LOADING_AGENCY_PROPERTIES,
  LOADING_AGENCY_PROPERTIES_SUCCESS,
  LOADING_AGENCY_PROPERTIES_FAILURE
} from '../constants/agencyPropertiesTypes'

// Loading and failure keep the brand's previous list: the tab refetches on every
// mount, and nulling `data` would blank the table each time.
export default function reducer(state = {}, actions) {
  switch (actions.type) {
    case LOADING_AGENCY_PROPERTIES:
      return {
        ...state,
        [actions.brandId]: {
          loading: true,
          success: null,
          data: get(state, [actions.brandId, 'data'], null),
          errors: null
        }
      }
    case LOADING_AGENCY_PROPERTIES_SUCCESS:
      return {
        ...state,
        [actions.brandId]: {
          loading: false,
          success: true,
          data: actions.data ? [...actions.data] : [],
          errors: null
        }
      }
    case LOADING_AGENCY_PROPERTIES_FAILURE:
      return {
        ...state,
        [actions.brandId]: {
          loading: false,
          success: false,
          data: get(state, [actions.brandId, 'data'], null),
          errors: actions.errors
        }
      }
    default:
      return state
  }
}
